namespace TabAurous.Production {
    export interface MFGTransactionItemsForm {
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        VoucherNo: Serenity.StringEditor;
        TreeId: Serenity.StringEditor;
        TreeItemId: Serenity.StringEditor;
        PureWeight: WeightEditor;
        Purity: Serenity.DecimalEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        OrderTypeId: Serenity.IntegerEditor;
        OrderTransId: Serenity.IntegerEditor;
        OrderTransItemId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        ImageName: Serenity.StringEditor;
        Parts: Serenity.IntegerEditor;
        BagNo: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        SubBagNo: Serenity.IntegerEditor;
        TreeNo: Serenity.StringEditor;
        Line_No: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        QualityInspectionValue: _Ext.YesNoEditor;
        Button: ButtonEditor;
        QualityInspection: MFGInspectionValuesEditor;
        FromPieces: Serenity.IntegerEditor;
        ProductItemImage: Serenity.ImageUploadEditor;
        FromDeptId: Serenity.LookupEditor;
        FromProcessId: MFGProcessLookup;
        FromWorkerId: Serenity.LookupEditor;
        FromWeight: WeightEditor;
        FromDiamondPieces: Serenity.IntegerEditor;
        FromNetWeight: WeightEditor;
        FromDiamondWeight: WeightEditor;
        FromStonePieces: Serenity.IntegerEditor;
        FromOtherPieces: Serenity.IntegerEditor;
        FromStoneWeight: WeightEditor;
        FromOtherWeight: WeightEditor;
        LossPercent: Serenity.DecimalEditor;
        Loss: Serenity.DecimalEditor;
        ToPieces: Serenity.IntegerEditor;
        ToDeptId: Serenity.LookupEditor;
        ToProcessId: MFGProcessLookup;
        ToWorkerId: Serenity.LookupEditor;
        ToWeight: WeightEditor;
        ToDiamondPieces: Serenity.IntegerEditor;
        ToNetWeight: WeightEditor;
        ToDiamondWeight: WeightEditor;
        ToStonePieces: Serenity.IntegerEditor;
        ToOtherPieces: Serenity.IntegerEditor;
        ToStoneWeight: WeightEditor;
        ToOtherWeight: WeightEditor;
        BOMDetails: MFGTransactionBOMEditor;
        LossDetails: MFGTransactionLossEditor;
    }

    export class MFGTransactionItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.MFGTransactionItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MFGTransactionItemsForm.init)  {
                MFGTransactionItemsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = WeightEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = _Ext.YesNoEditor;
                var w5 = ButtonEditor;
                var w6 = MFGInspectionValuesEditor;
                var w7 = s.ImageUploadEditor;
                var w8 = s.LookupEditor;
                var w9 = MFGProcessLookup;
                var w10 = MFGTransactionBOMEditor;
                var w11 = MFGTransactionLossEditor;

                Q.initFormType(MFGTransactionItemsForm, [
                    'ProductId', w0,
                    'AttributeId', w0,
                    'VoucherNo', w0,
                    'TreeId', w0,
                    'TreeItemId', w0,
                    'PureWeight', w1,
                    'Purity', w2,
                    'CompanyId', w3,
                    'FinancialYearId', w3,
                    'RefVoucherId', w3,
                    'RefTransId', w0,
                    'RefTransItemId', w0,
                    'OrderTypeId', w3,
                    'OrderTransId', w3,
                    'OrderTransItemId', w3,
                    'UserId', w3,
                    'ImageName', w0,
                    'Parts', w3,
                    'BagNo', w0,
                    'LotNo', w0,
                    'SubBagNo', w3,
                    'TreeNo', w0,
                    'Line_No', w0,
                    'ProductCode', w0,
                    'Attribute', w0,
                    'QualityInspectionValue', w4,
                    'Button', w5,
                    'QualityInspection', w6,
                    'FromPieces', w3,
                    'ProductItemImage', w7,
                    'FromDeptId', w8,
                    'FromProcessId', w9,
                    'FromWorkerId', w8,
                    'FromWeight', w1,
                    'FromDiamondPieces', w3,
                    'FromNetWeight', w1,
                    'FromDiamondWeight', w1,
                    'FromStonePieces', w3,
                    'FromOtherPieces', w3,
                    'FromStoneWeight', w1,
                    'FromOtherWeight', w1,
                    'LossPercent', w2,
                    'Loss', w2,
                    'ToPieces', w3,
                    'ToDeptId', w8,
                    'ToProcessId', w9,
                    'ToWorkerId', w8,
                    'ToWeight', w1,
                    'ToDiamondPieces', w3,
                    'ToNetWeight', w1,
                    'ToDiamondWeight', w1,
                    'ToStonePieces', w3,
                    'ToOtherPieces', w3,
                    'ToStoneWeight', w1,
                    'ToOtherWeight', w1,
                    'BOMDetails', w10,
                    'LossDetails', w11
                ]);
            }
        }
    }
}
